import React from 'react';
import ReactDOM from 'react-dom/client';
import '@maersk-global/fonts/maeu/fonts.css';
import '@maersk-global/mds-design-tokens/apmterminals/light/css/design-tokens-px.css';
import '@maersk-global/mds-foundations/css/foundations.min.css';
import '@maersk-global/mds-components-core';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MdsConfig } from '@maersk-global/mds-config';

// Icons are served as ES modules from public/@maersk-global/icons/js/
// The path prefix '/' makes imports resolve to /@maersk-global/icons/js/{size}px/mi-{icon}.js
MdsConfig.iconsDynamicImportPath = '/';

// Suppress ResizeObserver loop errors that trigger the CRA error overlay in development.
// These are benign warnings from browser layout recalc and do not affect functionality.
const resizeObserverErr = (e: Event | PromiseRejectionEvent) => {
  const msg = 'message' in e ? (e as ErrorEvent).message : '';
  const reason = 'reason' in e ? String((e as PromiseRejectionEvent).reason) : '';
  if (
    msg === 'ResizeObserver loop completed with undelivered notifications.' ||
    msg === 'ResizeObserver loop limit exceeded' ||
    reason.includes('ResizeObserver')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();            // prevents CRA's error overlay
  }
};
window.addEventListener('error', resizeObserverErr);
window.addEventListener('unhandledrejection', resizeObserverErr);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
